import type { JSX } from 'cdui-js';
import { If } from 'cdui-js';
import { isFundHideNav } from '../deposit/h5-deposit/appBridge';

export type CrsNavProps = {
  title: string;
  onBack: () => void;
  onClose?: () => void;
  right?: () => JSX.Element;
};

const IconBack = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
    <path d="M15 5L8 12L15 19" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
);

const IconClose = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
    <path d="M6 6L18 18M18 6L6 18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
  </svg>
);

/** App 已画顶栏（hideNav=1）时不渲染。浏览器单独打开仍用这套导航。 */
export const CrsNav = (props: CrsNavProps) => (
  <If when={!isFundHideNav()}>
    <div class="crs-nav">
      <button type="button" class="crs-nav-btn" onclick={props.onBack}>
        <IconBack />
      </button>
      <div class="crs-nav-title">{props.title}</div>
      <div class="crs-nav-side">
        <If when={!!props.onClose}>
          <button type="button" class="crs-nav-btn" onclick={props.onClose}>
            <IconClose />
          </button>
        </If>
        <If when={!props.onClose && !!props.right}>{props.right ? props.right() : null}</If>
      </div>
    </div>
  </If>
);
